// Dependencias
import React, { useEffect, useState, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axiosInstance from '../../../services/AxiosInstance';
import { useTranslation } from 'react-i18next';

// Componentes
import BannerFichas from '../../../components/BannerFichas/BannerFichas';
import Navbar from '../../../components/Navbar/Navbar';
import SessionBar from '../../../components/SessionBar/SessionBar';
import Footer from '../../../components/Footer/Footer';

// Funciones
import { ROUTES } from '../../../const/routes';
import { useUser } from '../../../context/UserContext';

const MercadoPagoSuccess = () => {
  const { userData, silentRefreshUserData } = useUser();
  const { t } = useTranslation();
  const [monto, setMonto] = useState(null);
  const [registroExitoso, setRegistroExitoso] = useState(false);
  const [error, setError] = useState(null);
  const location = useLocation();
  const hasRegistered = useRef(false);

  useEffect(() => {
    const registerPayment = async () => {
      if (hasRegistered.current) return;
      if (!userData) return;

      hasRegistered.current = true;

      try {
        const params = new URLSearchParams(location.search);
        const paymentId = params.get('payment_id');
        const status = params.get('status');
        const preferenceId = params.get('preference_id');

        if (status === 'approved' && paymentId) {
          const response = await axiosInstance.post(
            '/api/mercadoPago/registerPayment',
            {
              paymentId: paymentId,
              status: status,
              preferenceId: preferenceId,
            }
          );

          if (response.data) {
            setMonto(response.data.monto);
            setRegistroExitoso(true);
            await silentRefreshUserData();
          }
        } else {
          setError('El pago no fue aprobado o faltan datos');
        }
      } catch (error) {
        setError(error.response?.data?.msg || 'Error al procesar el pago');
        hasRegistered.current = false;
      }
    };

    registerPayment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData]);

  const formatCurrency = (value) => {
    return value.toLocaleString('es-AR', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2,
    });
  };

  return (
    <div>
      <BannerFichas />
      <div className="bg-gradient-to-b from-slate-950 to-violet-950 min-h-screen">
        <Navbar />
        <SessionBar />

        {error && (
          <div className="flex flex-col items-center justify-center py-4">
            <div className="bg-red-900 border border-red-700 text-white px-4 py-3 rounded">
              <p className="font-bold">{t('paymentSuccess.errorLabel')}</p>
              <p>{error}</p>
            </div>
          </div>
        )}

        {new URLSearchParams(location.search).get('payment_id') ? (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {registroExitoso
                ? t('paymentSuccess.title1')
                : t('paymentSuccess.title2')}
            </h2>
            <p className="text-sm text-gray-300 mb-8">
              {registroExitoso
                ? t('paymentSuccess.message1')
                : t('paymentSuccess.message2')}
            </p>
            <div className="flex space-x-10">
              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center">
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {t('paymentSuccess.loadedAmount')}
                </p>
                <h2 className="text-yellow-500 text-lg font-bold mb-2">
                  ${monto ? formatCurrency(monto) : '-'}
                </h2>
                {monto && (
                  <img
                    src={
                      ROUTES.rutaFichasPoker +
                      'FichaPoker' +
                      monto +
                      'Resized.png'
                    }
                    alt="Item"
                    className="w-60 object-cover mb-4"
                  />
                )}
              </div>

              <div className="bg-bgContenedorOscuro border-solid border-4 border-borderContenedorOscuro shadow-shadowContenedorOscuro shadow-lg rounded-lg p-6 flex flex-col items-center w-max">
                <h2
                  className={`text-lg font-bold mb-2 max-w-80 text-center ${
                    registroExitoso ? 'text-green-400' : 'text-yellow-500'
                  }`}
                >
                  {registroExitoso
                    ? t('paymentSuccess.title1')
                    : t('paymentSuccess.processing')}
                </h2>
                <p className="text-sm text-gray-300 mb-4 max-w-80">
                  {registroExitoso
                    ? `${t('paymentSuccess.successDetail')} $${formatCurrency(monto)} ${t('paymentSuccess.toAccount')}`
                    : t('paymentSuccess.unavailable')}
                </p>
              </div>
            </div>
          </div>
        ) : (
          <div className="flex flex-col flex-grow items-center justify-center text-center py-10">
            <h2 className="text-2xl text-yellow-500 font-bold mb-4">
              {t('paymentSuccess.unavailable')}
            </h2>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default MercadoPagoSuccess;
